export default __webpack_public_path__ + "static/media/landing1.5bc8a45b.png";